// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__lZqlc","icon-marker_venue":"Icon_icon-marker_venue__37zmB"};